import { useState } from 'react';
import {
  Box,
  Typography,
  Button,
} from '@mui/material';
// components
import DIOText from '../../components/DIOText';
import Iconify from '../../components/Iconify';
import {
  FirstOnDialog,
} from '../timetracking';

// -----------------------------------------

export default function OnboardingCard() {
  const [isFirstOnDialogOpen, setIsFirstOnDialogOpen] = useState(false);

  return (
    <Box sx={{ p: 3, pb: 2, borderRadius: 2, backgroundColor: "grey.100", mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        🎉 첫 한 달간 온보딩 데일리 투두를 제공하고 있어요.
      </Typography>
      <Typography variant="body2" gutterBottom>
        회사와의 성공적인 협업을 위해 데일리 투두를 목표일까지 완료하고, 완료 체크해주세요!
      </Typography>
      <Button
        sx={{ color: "text.secondary" }}
        startIcon={<Iconify icon="eva:info-fill" />}
        onClick={() => setIsFirstOnDialogOpen(true)}
        disableFocusRipple
      >
        <DIOText />&nbsp;첫 출근 업무 가이드
      </Button>
      <FirstOnDialog
        isOpen={isFirstOnDialogOpen}
        closeDialog={() => setIsFirstOnDialogOpen(false)}
      />
    </Box>
  )
}